import React from "react";
import TwoCol from "../../containers/twoCol";
import CircleFacts from "../CircleFactoids";

const FactoidBlock = ({
  row,
  padding,
  colHeight,
  ImageBG,
  circleFactPosition,
  item_id,
  linkColor,
}) => (
  <TwoCol
    textAlign="center"
    className={"FactoidContainer " + linkColor}
    styles={{
      fontFamily: "Oswald, sans-serif",
      padding: padding,
      textTransform: "uppercase",
      lineHeight: " 19px",
      maxWidth: window.innerWidth > 899 ? "600px" : "100vw",
      width: window.innerWidth > 899 ? "50%" : "100vw",
      border: "0px dashed #cc00cc",
      display: "inline-block",
      float: "left",
      ...ImageBG,
      height: colHeight,
      textAlign: "center",
    }}
  >
    <CircleFacts
      factoid={row.field_factoids}
      instanceID={item_id}
      style={{
        fontFamily: "Oswald, sans-serif",
        padding: "0px",
        textTransform: "uppercase",
        lineHeight: " 19px",
        maxWidth: "313px",
        width: "313px",
        border: "0px dashed #cc00cc",
        display: "inline-block",
        height: "480px",
        backgroundColor: "#FFD416",
        ...circleFactPosition,
      }}
    />
  </TwoCol>
);

export default FactoidBlock;
